import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store' // 如果使用 Vuex/Pinia

// 引入 Vant 组件 和样式
import {
    Button, Form, Field, CellGroup, NavBar, Tabbar, TabbarItem, List, Cell,
    Dialog, Notify, Uploader, Popup, Picker, DatePicker, ConfigProvider, Icon, Tag,
    Tabs, Tab, RadioGroup, Radio, Loading, Sticky // <--- 新增导入 RadioGroup 和 Radio
} from 'vant';
import 'vant/lib/index.css';     // Vant 核心样式 (必须在自定义主题前)
import './assets/css/theme.css'; // 导入自定义主题样式

// 如果是按需引入，确保相关组件的样式也被引入，但全量引入 index.css 通常已包含
// import 'vant/es/dialog/style'; // Dialog 样式 (如果按需引入)
// import 'vant/es/notify/style'; // Notify 样式 (如果按需引入)
// import 'vant/es/radio/style'; // Radio 样式 (如果按需引入，但全量index.css应该包含了)


const app = createApp(App);

app.use(router);
// app.use(store); // 如果使用 Vuex/Pinia

// 注册 Vant 组件
app.use(Button);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(NavBar);
app.use(Tabbar);
app.use(TabbarItem);
app.use(List);
app.use(Cell);
app.use(Dialog);    // 用于 Dialog.confirm 等函数式调用，以及 <van-dialog> 组件
// app.use(Notify); // Notify 现在通过 import { showNotify } from 'vant'; 在组件中使用，通常不再需要全局 use Notify 组件本身，除非也想用 <van-notify> 标签
app.use(Uploader);
app.use(Popup);
app.use(Picker);
app.use(DatePicker);
app.use(ConfigProvider);
app.use(Icon);
app.use(Tag);
app.use(Loading);
app.use(Sticky);     // <--- 确保 Sticky 被注册 (因为 LibrarianList.vue 中用了 van-sticky)
app.use(Tabs);       // <--- 新增注册 Tabs
app.use(Tab);        // <--- 新增注册 Tab
app.use(RadioGroup); // <--- 新增注册 RadioGroup
app.use(Radio);      // <--- 新增注册 Radio

app.mount('#app');